var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiCharacters(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 40 40",
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ai-characters_svg__clip0_1306_6791)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 20c6.075 0 11 4.925 11 11v7a2 2 0 11-4 0v-7a7 7 0 10-14 0v7a2 2 0 11-4 0v-7c0-6.075 4.925-11 11-11zm0-18a7 7 0 110 14 7 7 0 010-14zm0 4a3 3 0 100 6 3 3 0 000-6z",
    fill: "url(#ai-characters_svg__paint0_linear_1306_6791)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 20c6.075 0 11 4.925 11 11v7a2 2 0 11-4 0v-7a7 7 0 00-10.887-5.822 2.001 2.001 0 01-2.226-3.325A10.959 10.959 0 0129 20zm0-18a7 7 0 110 14 7 7 0 010-14zm0 4a3 3 0 100 6 3 3 0 000-6z",
    fill: "#ACB5C2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ai-characters_svg__paint0_linear_1306_6791",
    x1: 0,
    y1: 41.025,
    x2: 33.194,
    y2: 24.398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60F3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#00CCBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009AC0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ai-characters_svg__clip0_1306_6791"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v40H0z"
  })))));
}
export default __webpack_public_path__ + "fonts/ai-characters-e92df5fad3e0fcc0188da193f90ded73.svg";
export { SvgAiCharacters as ReactComponent };